import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import { useAuth } from '../../contexts/AuthContext'
import { Button } from '../ui'
import { LanguagePicker } from '../ui/LanguagePicker'
import { CONTACT } from '../../config/contact'
import BrandMark from './BrandMark'

const NAV_LINKS = [
  { labelId: 'marketing.nav.parcours', href: '#parcours' },
  { labelId: 'marketing.nav.change', href: '#changement' },
  { labelId: 'marketing.nav.report', href: '#rapport' },
]

const MarketingNav: React.FC = () => {
  const { user } = useAuth()
  const [mobileOpen, setMobileOpen] = useState(false)

  const scrollTo = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault()
    const el = document.querySelector(href)
    el?.scrollIntoView({ behavior: 'smooth' })
    setMobileOpen(false)
  }

  return (
    <nav className="sticky top-0 z-50 bg-surface/95 backdrop-blur border-b border-border-light">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center gap-8">
            <Link to="/" className="flex items-center gap-2 text-xl font-heading font-bold text-primary-dark">
              <BrandMark className="h-7 w-7" />
              Sondely
            </Link>
            <div className="hidden md:flex items-center gap-6">
              {NAV_LINKS.map(link => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={e => scrollTo(e, link.href)}
                  className="text-sm font-medium text-foreground-muted hover:text-foreground transition-colors"
                >
                  <FormattedMessage id={link.labelId} />
                </a>
              ))}
            </div>
          </div>
          <div className="flex items-center gap-3">
            <LanguagePicker />
            {user ? (
              <Link to="/dashboard">
                <Button variant="primary" size="sm"><FormattedMessage id="marketing.nav.dashboard" /></Button>
              </Link>
            ) : (
              <>
                <Link to="/auth/signin" className="hidden sm:block">
                  <Button variant="ghost" size="sm"><FormattedMessage id="marketing.nav.signIn" /></Button>
                </Link>
                <a href={CONTACT.bookingUrl} target="_blank" rel="noreferrer" className="hidden sm:block">
                  <Button variant="primary" size="sm"><FormattedMessage id="marketing.nav.talk" /></Button>
                </a>
              </>
            )}
            <button
              className="md:hidden p-2 text-foreground-muted"
              onClick={() => setMobileOpen(!mobileOpen)}
              aria-expanded={mobileOpen}
            >
              <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                {mobileOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>
      </div>
      {/* Mobile menu */}
      {mobileOpen && (
        <div className="md:hidden border-t border-border-light bg-surface px-4 py-3 space-y-2">
          {NAV_LINKS.map(link => (
            <a
              key={link.href}
              href={link.href}
              onClick={e => scrollTo(e, link.href)}
              className="block py-2 text-sm text-foreground-muted hover:text-foreground"
            >
              <FormattedMessage id={link.labelId} />
            </a>
          ))}
          {!user && (
            <>
              <Link to="/auth/signin" className="block py-2 text-sm text-foreground-muted hover:text-foreground">
                <FormattedMessage id="marketing.nav.signIn" />
              </Link>
              <a href={CONTACT.bookingUrl} target="_blank" rel="noreferrer" className="block pt-2">
                <Button variant="primary" size="sm" className="w-full"><FormattedMessage id="marketing.nav.talk" /></Button>
              </a>
            </>
          )}
        </div>
      )}
    </nav>
  )
}

export default MarketingNav
